module.exports = __webpack_public_path__ + "static/media/CTAImage.c20ef305.svg";